/* RESPONSIBLE TEAM: team-actions */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';
import Validations from 'embercom/validations/custom-authentication/oauth-token-configuration';
import { tracked } from '@glimmer/tracking';
import {
  getOAuthProviderFromTokenUrl,
  isSalesforceSandboxUrl,
} from 'embercom/lib/oauth/provider-detection';

export enum RequestFormat {
  JSON = 'json',
  FORM_ENCODED = 'form_encoded',
}

export default class OauthTokenConfiguration extends Fragment.extend(Validations) {
  @attr('string') declare url: string;
  @attr('string') declare clientId: string;
  @attr('string') declare clientSecret: string;
  @attr('string') declare scope: string;
  @attr('string', { defaultValue: RequestFormat.JSON }) declare requestFormat: RequestFormat;
  @attr('string') declare grantType: string;

  @tracked mostRecentTestPassed = false;
  @tracked declare latestTestRequestParams: OauthTokenConfiguration;

  get contentType() {
    return this.requestFormat === RequestFormat.JSON
      ? 'application/json'
      : 'application/x-www-form-urlencoded';
  }

  get sufficientlyTested() {
    if (this.latestTestRequestParams === undefined) {
      return false;
    }

    if (!this.mostRecentTestPassed) {
      return false;
    }

    return this._testSinceLastEdit();
  }

  get isAuthCodeGrantType() {
    return this.grantType === 'authorization_code';
  }

  get provider() {
    return getOAuthProviderFromTokenUrl(this.url);
  }

  get isSandbox() {
    if (this.provider === 'salesforce') {
      return isSalesforceSandboxUrl(this.url);
    }

    return false;
  }

  _testSinceLastEdit() {
    return this._configsMatch(this, this.latestTestRequestParams);
  }

  _configsMatch(currentConfig: OauthTokenConfiguration, testedConfig: OauthTokenConfiguration) {
    return (
      currentConfig.url === testedConfig.url &&
      currentConfig.clientId === testedConfig.clientId &&
      currentConfig.clientSecret === testedConfig.clientSecret &&
      currentConfig.scope === testedConfig.scope &&
      currentConfig.requestFormat === testedConfig.requestFormat
    );
  }
}
